// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
export type ResponseFragment = {
  __typename?: 'Message'
  creationDate: any
  text: string
  relevancyFit: Types.RelevancyFit
}

export const ResponseFragmentDoc = gql`
  fragment Response on Message {
    creationDate
    text
    relevancyFit
  }
`
